import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  ConsultRateDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayConsultRateSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.CONSULT_RATE?.submetrics) {
    return <></>;
  }
  if (ConsultRateDataCheck(metrics.CONSULT_RATE?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { consults, phoneHandledContacts } = metrics.CONSULT_RATE?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {consults && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_consultContacts'
                  defaultMessage='Consult Contacts'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_consultContacts_def'
                defaultMessage='Sum of phone handled contacts where the associate calling in did not transfer the customer to the associate answering it.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={consults.datapoint} isBold />
          <DisplaySubMetric
            value={consults.networkAverage}
            datapointNull={consults.datapoint === null}
          />
        </Row>
      )}
      {phoneHandledContacts && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_phoneHandledContacts'
                  defaultMessage='Phone Handled Contacts'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_phoneHandledContacts_def'
                defaultMessage='Sum of phone contacts considered “Handled”.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={phoneHandledContacts.datapoint} isBold />
          <DisplaySubMetric
            value={phoneHandledContacts.networkAverage}
            datapointNull={phoneHandledContacts.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayConsultRateSubMetrics;
